export interface Milestone {
  age_group: string;
  area: 'motor_gross' | 'motor_fine' | 'language' | 'social';
  milestone: string;
}

export const developmentalMilestones: Milestone[] = [
  { age_group: 'RN', area: 'motor_gross', milestone: 'Mantiene la cabeza erguida momentáneamente' },
  { age_group: 'RN', area: 'motor_gross', milestone: 'Movimientos de extremidades simétricos' },
  { age_group: 'RN', area: 'motor_gross', milestone: 'Reflejo de Moro presente' },
  { age_group: 'RN', area: 'motor_gross', milestone: 'Reflejo de búsqueda y succión' },
  { age_group: 'RN', area: 'motor_fine', milestone: 'Manos cerradas en puño' },
  { age_group: 'RN', area: 'motor_fine', milestone: 'Fija la mirada en objetos a 20-30 cm' },
  { age_group: 'RN', area: 'motor_fine', milestone: 'Sigue objetos con la mirada' },
  { age_group: 'RN', area: 'language', milestone: 'Llora como forma de comunicación' },
  { age_group: 'RN', area: 'language', milestone: 'Emite sonidos guturales' },
  { age_group: 'RN', area: 'language', milestone: 'Se sobresalta ante ruidos fuertes' },
  { age_group: 'RN', area: 'social', milestone: 'Prefiere mirar rostros humanos' },
  { age_group: 'RN', area: 'social', milestone: 'Se calma al ser cargado o escuchar la voz de la madre' },
  { age_group: 'RN', area: 'social', milestone: 'Sonrisa refleja' },

  { age_group: '2m', area: 'motor_gross', milestone: 'Levanta la cabeza y el pecho en decúbito prono' },
  { age_group: '2m', area: 'motor_gross', milestone: 'Sostiene la cabeza brevemente' },
  { age_group: '2m', area: 'motor_gross', milestone: 'Mueve ambas piernas activamente' },
  { age_group: '2m', area: 'motor_fine', milestone: 'Sigue objetos en movimiento' },
  { age_group: '2m', area: 'motor_fine', milestone: 'Abre y cierra las manos' },
  { age_group: '2m', area: 'motor_fine', milestone: 'Lleva objetos a la boca' },
  { age_group: '2m', area: 'language', milestone: 'Emite sonidos vocálicos (a-a-a, e-e-e)' },
  { age_group: '2m', area: 'language', milestone: 'Vocaliza en respuesta a la voz' },
  { age_group: '2m', area: 'language', milestone: 'Gira la cabeza hacia los sonidos' },
  { age_group: '2m', area: 'social', milestone: 'Sonrisa social' },
  { age_group: '2m', area: 'social', milestone: 'Sigue con la mirada a las personas' },
  { age_group: '2m', area: 'social', milestone: 'Se tranquiliza al ser cargado' },

  { age_group: '4m', area: 'motor_gross', milestone: 'Sostiene la cabeza firmemente' },
  { age_group: '4m', area: 'motor_gross', milestone: 'Se empuja con los brazos en decúbito prono' },
  { age_group: '4m', area: 'motor_gross', milestone: 'Rueda de prono a supino' },
  { age_group: '4m', area: 'motor_fine', milestone: 'Agita y sacude sonajeros' },
  { age_group: '4m', area: 'motor_fine', milestone: 'Junta las manos en la línea media' },
  { age_group: '4m', area: 'motor_fine', milestone: 'Alcanza objetos voluntariamente' },
  { age_group: '4m', area: 'language', milestone: 'Balbucea y hace sonidos de arrullo' },
  { age_group: '4m', area: 'language', milestone: 'Ríe a carcajadas' },
  { age_group: '4m', area: 'language', milestone: 'Imita algunos sonidos' },
  { age_group: '4m', area: 'social', milestone: 'Se reconoce en el espejo' },
  { age_group: '4m', area: 'social', milestone: 'Disfruta jugando con personas' },
  { age_group: '4m', area: 'social', milestone: 'Se aburre si lo dejan solo' },

  { age_group: '6m', area: 'motor_gross', milestone: 'Se sienta con apoyo' },
  { age_group: '6m', area: 'motor_gross', milestone: 'Se mantiene en pie con apoyo' },
  { age_group: '6m', area: 'motor_gross', milestone: 'Rueda en ambas direcciones' },
  { age_group: '6m', area: 'motor_fine', milestone: 'Pasa objetos de una mano a otra' },
  { age_group: '6m', area: 'motor_fine', milestone: 'Palmea objetos' },
  { age_group: '6m', area: 'motor_fine', milestone: 'Usa toda la mano para agarrar (presa palmar)' },
  { age_group: '6m', area: 'language', milestone: 'Balbucea con sonidos consonánticos (ba-ba, da-da)' },
  { age_group: '6m', area: 'language', milestone: 'Reconoce su nombre' },
  { age_group: '6m', area: 'language', milestone: 'Hace sonidos para mostrar alegría o desagrado' },
  { age_group: '6m', area: 'social', milestone: 'Distingue entre familiares y extraños' },
  { age_group: '6m', area: 'social', milestone: 'Disfruta juegos interactivos (cu-cú)' },
  { age_group: '6m', area: 'social', milestone: 'Responde a las emociones de otros' },

  { age_group: '9m', area: 'motor_gross', milestone: 'Se sienta sin apoyo' },
  { age_group: '9m', area: 'motor_gross', milestone: 'Gatea' },
  { age_group: '9m', area: 'motor_gross', milestone: 'Se pone de pie con apoyo' },
  { age_group: '9m', area: 'motor_gross', milestone: 'Da pasos laterales sostenido de muebles' },
  { age_group: '9m', area: 'motor_fine', milestone: 'Pinza índice-pulgar' },
  { age_group: '9m', area: 'motor_fine', milestone: 'Golpea objetos entre sí' },
  { age_group: '9m', area: 'motor_fine', milestone: 'Busca objetos escondidos' },
  { age_group: '9m', area: 'language', milestone: 'Dice "mamá" y "papá" (no específico)' },
  { age_group: '9m', area: 'language', milestone: 'Entiende "no"' },
  { age_group: '9m', area: 'language', milestone: 'Escucha selectivamente palabras familiares' },
  { age_group: '9m', area: 'social', milestone: 'Ansiedad ante extraños' },
  { age_group: '9m', area: 'social', milestone: 'Juega a palmear (tortitas)' },
  { age_group: '9m', area: 'social', milestone: 'Imita gestos simples' },

  { age_group: '12m', area: 'motor_gross', milestone: 'Camina con apoyo o de la mano' },
  { age_group: '12m', area: 'motor_gross', milestone: 'Se pone de pie sin ayuda' },
  { age_group: '12m', area: 'motor_gross', milestone: 'Se agacha y vuelve a levantarse' },
  { age_group: '12m', area: 'motor_fine', milestone: 'Usa la pinza fina correctamente' },
  { age_group: '12m', area: 'motor_fine', milestone: 'Mete y saca objetos de contenedores' },
  { age_group: '12m', area: 'motor_fine', milestone: 'Pasa páginas de un libro (varias a la vez)' },
  { age_group: '12m', area: 'language', milestone: 'Dice 1-3 palabras con sentido' },
  { age_group: '12m', area: 'language', milestone: 'Señala objetos de interés' },
  { age_group: '12m', area: 'language', milestone: 'Responde a órdenes simples ("dame")' },
  { age_group: '12m', area: 'social', milestone: 'Juegos de imitación social' },
  { age_group: '12m', area: 'social', milestone: 'Cooperación en vestirse' },
  { age_group: '12m', area: 'social', milestone: 'Ansiedad de separación' },

  { age_group: '15m', area: 'motor_gross', milestone: 'Camina solo (caídas frecuentes)' },
  { age_group: '15m', area: 'motor_gross', milestone: 'Se agacha para recoger objetos' },
  { age_group: '15m', area: 'motor_gross', milestone: 'Sube escaleras gateando' },
  { age_group: '15m', area: 'motor_fine', milestone: 'Construye torres de 2 cubos' },
  { age_group: '15m', area: 'motor_fine', milestone: 'Garabatea espontáneamente' },
  { age_group: '15m', area: 'motor_fine', milestone: 'Usa la cuchara con ayuda' },
  { age_group: '15m', area: 'language', milestone: 'Dice 4-6 palabras' },
  { age_group: '15m', area: 'language', milestone: 'Señala partes del cuerpo' },
  { age_group: '15m', area: 'language', milestone: 'Usa jerga con entonación conversacional' },
  { age_group: '15m', area: 'social', milestone: 'Juego paralelo' },
  { age_group: '15m', area: 'social', milestone: 'Imita actividades domésticas' },
  { age_group: '15m', area: 'social', milestone: 'Abraza y besa' },

  { age_group: '18m', area: 'motor_gross', milestone: 'Camina solo y firme' },
  { age_group: '18m', area: 'motor_gross', milestone: 'Corre rígidamente' },
  { age_group: '18m', area: 'motor_gross', milestone: 'Sube escaleras con ayuda' },
  { age_group: '18m', area: 'motor_fine', milestone: 'Construye torres de 3-4 cubos' },
  { age_group: '18m', area: 'motor_fine', milestone: 'Pasa páginas una por una' },
  { age_group: '18m', area: 'motor_fine', milestone: 'Usa la cuchara sin ayuda' },
  { age_group: '18m', area: 'language', milestone: 'Dice 10-15 palabras' },
  { age_group: '18m', area: 'language', milestone: 'Combina dos palabras (frases simples)' },
  { age_group: '18m', area: 'language', milestone: 'Sigue órdenes de dos pasos' },
  { age_group: '18m', area: 'social', milestone: 'Juego simbólico simple' },
  { age_group: '18m', area: 'social', milestone: 'Ayuda con tareas simples' },
  { age_group: '18m', area: 'social', milestone: 'Muestra afecto espontáneamente' },

  { age_group: '24m', area: 'motor_gross', milestone: 'Corre bien y evita obstáculos' },
  { age_group: '24m', area: 'motor_gross', milestone: 'Sube y baja escaleras solo (ambos pies)' },
  { age_group: '24m', area: 'motor_gross', milestone: 'Patea una pelota' },
  { age_group: '24m', area: 'motor_fine', milestone: 'Construye torres de 6-7 cubos' },
  { age_group: '24m', area: 'motor_fine', milestone: 'Garabatea y hace trazos circulares' },
  { age_group: '24m', area: 'motor_fine', milestone: 'Se quita prendas simples' },
  { age_group: '24m', area: 'language', milestone: 'Dice 50+ palabras' },
  { age_group: '24m', area: 'language', milestone: 'Frases de 2-3 palabras' },
  { age_group: '24m', area: 'language', milestone: 'Usa pronombres (yo, mí, mío)' },
  { age_group: '24m', area: 'social', milestone: 'Juego paralelo con interacción ocasional' },
  { age_group: '24m', area: 'social', milestone: 'Imita conductas de adultos' },
  { age_group: '24m', area: 'social', milestone: 'Afirma su independencia ("no")' },

  { age_group: '36m', area: 'motor_gross', milestone: 'Camina en puntillas' },
  { age_group: '36m', area: 'motor_gross', milestone: 'Se mantiene en un pie (1-2 seg)' },
  { age_group: '36m', area: 'motor_gross', milestone: 'Pedalea un triciclo' },
  { age_group: '36m', area: 'motor_fine', milestone: 'Copia un círculo' },
  { age_group: '36m', area: 'motor_fine', milestone: 'Construye torres de 9-10 cubos' },
  { age_group: '36m', area: 'motor_fine', milestone: 'Se viste y desviste con ayuda' },
  { age_group: '36m', area: 'language', milestone: 'Vocabulario de 300-500 palabras' },
  { age_group: '36m', area: 'language', milestone: 'Frases de 3-4 palabras' },
  { age_group: '36m', area: 'language', milestone: 'Dice nombre y edad' },
  { age_group: '36m', area: 'language', milestone: 'Cuenta historias simples' },
  { age_group: '36m', area: 'social', milestone: 'Juego cooperativo' },
  { age_group: '36m', area: 'social', milestone: 'Comparte y espera turnos' },
  { age_group: '36m', area: 'social', milestone: 'Muestra empatía básica' },

  { age_group: '48m', area: 'motor_gross', milestone: 'Salta en un pie' },
  { age_group: '48m', area: 'motor_gross', milestone: 'Atrapa una pelota' },
  { age_group: '48m', area: 'motor_gross', milestone: 'Camina en línea recta' },
  { age_group: '48m', area: 'motor_fine', milestone: 'Copia una cruz y un cuadrado' },
  { age_group: '48m', area: 'motor_fine', milestone: 'Dibuja una figura humana (3 partes)' },
  { age_group: '48m', area: 'motor_fine', milestone: 'Usa tijeras para recortar' },
  { age_group: '48m', area: 'language', milestone: 'Vocabulario de 1000+ palabras' },
  { age_group: '48m', area: 'language', milestone: 'Frases de 4-5 palabras' },
  { age_group: '48m', area: 'language', milestone: 'Cuenta historias largas' },
  { age_group: '48m', area: 'language', milestone: 'Hace preguntas constantemente' },
  { age_group: '48m', area: 'social', milestone: 'Juegos con reglas simples' },
  { age_group: '48m', area: 'social', milestone: 'Interactúa con otros niños' },
  { age_group: '48m', area: 'social', milestone: 'Distingue fantasía y realidad' },

  { age_group: '60m', area: 'motor_gross', milestone: 'Salta lazo o cuerda' },
  { age_group: '60m', area: 'motor_gross', milestone: 'Camina hacia atrás' },
  { age_group: '60m', area: 'motor_gross', milestone: 'Se balancea en un pie 5+ segundos' },
  { age_group: '60m', area: 'motor_fine', milestone: 'Copia un triángulo' },
  { age_group: '60m', area: 'motor_fine', milestone: 'Dibuja figura humana (6+ partes)' },
  { age_group: '60m', area: 'motor_fine', milestone: 'Escribe algunas letras' },
  { age_group: '60m', area: 'language', milestone: 'Vocabulario de 2000+ palabras' },
  { age_group: '60m', area: 'language', milestone: 'Usa tiempos verbales correctamente' },
  { age_group: '60m', area: 'language', milestone: 'Define palabras simples' },
  { age_group: '60m', area: 'language', milestone: 'Participa en conversaciones' },
  { age_group: '60m', area: 'social', milestone: 'Sigue reglas de juegos' },
  { age_group: '60m', area: 'social', milestone: 'Juego de roles complejo' },
  { age_group: '60m', area: 'social', milestone: 'Muestra independencia y responsabilidad' },
];
